import React from 'react'

const BrandSearchSvg = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{ isolation: 'isolate' }}
    viewBox="0 0 341.333 341.333"
    width={size || '100'}
    height={size || '100'}
  >
    <defs>
      <clipPath id="a">
        <path d="M0 0h341.333v341.333H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#a)">
      <path fill="#EDD708" d="M0 0h341.333v341.333H0z" />
      <path d="M98.879 170.667v93.466l47.067-.533c38.933-.533 48.267-1.067 54.8-2.933 33.6-9.6 50.4-42.934 37.2-73.2-4-8.8-10.8-15.467-21.067-20.534l-7.2-3.6 6.4-4.266c12.4-8.4 18.667-23.067 17.067-40.134-2-21.6-17.2-36.533-40.933-40.266-4.8-.8-27.734-1.467-50.934-1.467h-42.4v93.467zm92-68.934c14 5.334 20.267 18.8 16 34.4-2 6.8-7.466 12.934-14.666 16.267-5.467 2.533-8.8 2.8-37.6 3.2l-31.734.533v-28c0-15.333.4-28.266 1.067-28.8.533-.533 14.4-.8 30.933-.533 23.867.533 31.2 1.067 36 2.933zm9.734 79.867c10.8 5.333 14.8 11.6 15.333 24.4.667 12.267-1.333 18.133-8.4 25.333-8.933 8.934-13.867 9.867-52.267 9.867h-32.4v-31.733c0-17.467.267-32.134.534-32.4.266-.267 16.133-.267 35.066.133l34.4.667 7.734 3.733z" />
    </g>
  </svg>
)

export default BrandSearchSvg



// WEBPACK FOOTER //
// ./src/components/project-icons/BrandSearch.js